<h1 mat-dialog-title>
  <ng-container i18n="Exam Progress|Participation status title@@exam-progress-participation-status-title"
  >Participation Status</ng-container>
</h1>
<div mat-dialog-content #dialogContent class="full-width">
  <permission-checker [roles]="roles">
    <div class="info-data">
      <span class="text-disabled-color"
         i18n="Users List|Users List item 'name' title@@users-list-item-name-title">Name:</span>
      {{userName}}
    </div>

    <div *ngIf="!inProgress" class="info-data">
      <span class="text-disabled-color">
        <ng-container i18n="General|Status label@@general-status-label">Status</ng-container>:
      </span>
      <span *ngIf="notParticipated" class="color-primary">
        <ng-container i18n="Exam Progress|Not started label@@exam-progress-not-started-label">not started</ng-container>
      </span>
      <span *ngIf="participating" class="color-orange">
        <ng-container i18n="Exam Progress|In progress label@@exam-progress-in-progress-label">in progress</ng-container>
      </span>
      <span *ngIf="participated" class="color-green">
        <ng-container i18n="Exam Progress|Finished label@@exam-progress-finished-label">finished</ng-container>
      </span>
    </div>

    <div *ngIf="!inProgress && progress && progress.startedAt" class="info-data">
      <span class="text-disabled-color"
         i18n="Exam Progress|Answered questions count label@@exam-progress-answered-questions-count-label">
        Answered questions count:
      </span>
      {{answeredQuestionsCount}}
    </div>
  </permission-checker>
</div>
<div mat-dialog-actions>
  <app-button [disabled]="inProgress"
              [secondary]="true"
              (clicked)="closeModal()"
              label="Close"
              i18n-label="General|Close action label@@general-close-action-label"></app-button>
  <span *ngIf="proceedAllowed()" class="btn-spacer"></span>
  <app-button *ngIf="proceedAllowed()"
              label="Clear Progress"
              i18n-label="General|Clear progress action label@@general-clear-progress-action-label"
              [disabled]="inProgress || !proceedAllowed()"
              (clicked)="proceed()"></app-button>
</div>
